import type { MessengerMessage } from '@/api/client';
import type { TrackerChatMessage } from '@/components/Messenger/types/chatMessageTypes';
import { plainTextFromAssistantMessageParts } from '@/components/Messenger/agent/agentForwardPlainText';

export const AGENT_ASSISTANT_FORWARD_LABEL = 'Астра';

export function trackerAssistantMessageToForwardDraft(
  message: TrackerChatMessage
): MessengerMessage | null {
  const body = plainTextFromAssistantMessageParts(message.parts);
  if (!body.trim()) return null;
  return {
    id: message.id,
    thread_id: '',
    sender_id: '',
    body,
    created_at: new Date().toISOString(),
    forwarded_from_label: AGENT_ASSISTANT_FORWARD_LABEL,
  };
}
